import sanity from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

class CmsService {

    client = sanity;

    init = config => {
        this.client = this.client(config.cmsConfig);
        this.builder = imageUrlBuilder(this.client);
    }

    getDocumentById = id => this.client.getDocument(id);

    getDocumentsByIds = ids => {
        const query = `*[_id in ${ids}]`;
        return this.client.fetch(query);
    };

    getDocumentsByQuery = query => this.client.fetch(query);

    getDocumentsByType = type => {
        const query = `*[_type == '${type}']`;
        return this.client.fetch(query);
    };

    getImage = data => this.builder.image(data);
    getImageUrl = data => {
        const image = this.getImage(data);
        return image? image.url() : "";
    }
}

export default CmsService;
